/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - TOTAL COMMENTING REACTIONS REPORT : STYLES --------------- ++++++++++ */
export default {
    totalcommentingreactionsreport: {
        marginBottom: pxToEm(16)
    }
};
